export default __webpack_public_path__ + "static/media/Sage_artwork.b774ee63.png";